import uInput from './uInput';
import doubleInput from './doubleInput';
export { uInput, doubleInput }



// WEBPACK FOOTER //
// ./src/components/uInput/index.js